export enum DevelopersRoutes {
  Statistics = 'statistics',
  Documentation = 'documentation',
  DynamicData = 'dynamicData',
  UseApi = 'useApi'
}
